module.exports = __webpack_public_path__ + "static/media/partial-goals.379ef137.png";